var _path, _rect, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _rect2, _path7, _path8, _path9, _circle3, _circle4, _path10, _path11, _path12, _path13, _rect3, _path14, _path15, _path16, _path17, _circle5, _circle6, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterIconBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 553,
    height: 282,
    viewBox: "0 0 553 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 247.57L9.54025 200.346L55.5719 207.501L29.0978 241.846L21.7041 217.757L0 247.57Z",
    fill: "#FF3416"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.8413,
    y: 31.96,
    width: 180.349,
    height: 180.349,
    transform: "rotate(9.88822 38.8413 31.96)",
    fill: "#3FAC8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3668 139.763L39.6088 153.515",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5767 143.968L44.7553 155.988",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7228 152.875L46.9857 160.624",
    stroke: "black",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.2529,
    cy: 165.283,
    r: 13.5949,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.8679,
    cy: 164.329,
    r: 6.43967,
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.44 67.5723L68.1371 156.639L138.118 203.927L209.205 119.374L129.599 131.454L117.44 67.5723Z",
    fill: "#3E51C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.022 7.49154L165 65.8241L182.479 66.5705L216.163 27.8673L211.601 24.6832L202.838 29.8605L204.944 20.5556L199.938 17.7795L189.695 27.5911L196.618 15.5026L188.7 10.8941L183.556 21.3504L184.047 9.8413L179.022 7.49154Z",
    fill: "#3FAC8C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 209.356,
    y: 44.5928,
    width: 180.349,
    height: 180.349,
    transform: "rotate(4.10363 209.356 44.5928)",
    fill: "#FF3416"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M254.537 54.3797L248.779 68.1319",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M262.747 58.5856L253.925 70.6048",
    stroke: "black",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.893 67.4927L256.156 75.2414",
    stroke: "black",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.423,
    cy: 79.8995,
    r: 13.5949,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.038,
    cy: 78.9465,
    r: 6.43967,
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.055 45.8218L211.218 44.5992L214.5 91.0679L166.871 88.4857L195.969 67.2587L163.055 45.8218Z",
    fill: "#3E3092"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M286.684 236.121V190.805L290.977 188.42V236.121L298.133 237.552V242.322L292.409 239.46L295.271 249H290.977L288.115 239.46L282.868 242.322L280.483 239.46L286.684 236.121Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M310.509 246.138V200.822L305.868 198.437V246.138L298.133 247.569V252.339L304.321 249.477L301.227 259.017H305.868L308.962 249.477L314.635 252.339L317.213 249.477L310.509 246.138Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M533.883 33.9525L494.168 56.0619L477.079 23.7054L515.47 19.5614L501.179 38.3299L533.883 33.9525Z",
    fill: "#FF3416"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 324.368,
    y: 74.7412,
    width: 180.349,
    height: 180.349,
    transform: "rotate(-18.6151 324.368 74.7412)",
    fill: "#3E51C1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M342.569 272.985L397.52 224.87L380.674 211.838L319.983 226.62L322.279 232.992L334.628 234.008L325.993 241.775L329.016 248.054L346.094 245.504L330.715 252.651L335.343 262.798L347.808 256.024L339.228 267.116L342.569 272.985Z",
    fill: "#3E51C1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M435.925 44.7703L448.552 52.6968",
    stroke: "black",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M431.635 52.9369L445.769 57.6825",
    stroke: "black",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M431.74 63.7571L446.615 62.7564",
    stroke: "black",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5949,
    cy: 13.5949,
    r: 13.5949,
    transform: "matrix(-0.817515 0.575908 0.575908 0.817515 461.358 41.4414)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.43967,
    cy: 6.43967,
    r: 6.43967,
    transform: "matrix(-0.817515 0.575908 0.575908 0.817515 461.029 49.2578)",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M377.601 213.502L449.043 157.469L431.883 89.8334L350.151 133.458L401.616 154.59L377.601 213.502Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M447.721 246.137V200.821L455.843 198.436V246.137L469.38 247.568V252.338L458.551 249.476L463.965 259.016H455.843L450.429 249.476L440.502 252.338L435.989 249.476L447.721 246.137Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.967 247.932V202.558L141.222 200.17V247.932L129.981 249.365V254.141L138.974 251.275L134.477 260.828H141.222L145.719 251.275L153.963 254.141L157.71 251.275L147.967 247.932Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M175.696 247.932V202.558L168.951 200.17V247.932L157.71 249.365V254.141L166.703 251.275L162.206 260.828H168.951L173.448 251.275L181.692 254.141L185.439 251.275L175.696 247.932Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIconBottom);
export default __webpack_public_path__ + "static/media/footerIconBottom.721e6262a71ee9b0a515a172fb4e53ba.svg";
export { ForwardRef as ReactComponent };